import { debounce, clearUser } from 'common/js/util';

function logout() {
  clearUser();
  window.location.href = '/login';
}

document.addEventListener('mousemove', window.location.href.indexOf('/openLiveMeeting') === -1 ? debounce(logout, 120 * 60 * 1000) : debounce(logout, 24 * 60 * 60 * 1000), false);
